<template>
    <div class="dropdown-list">
        <div class="label">
            {{ config.label }}
            <template v-if="config.description">
                <br>
                <span class="description">
                    {{ config.description }}
                </span>
            </template>
        </div>
        <div class="lists-container">
            <div class="lists">
                <select
                    v-for="key in listKeys" :key="key" class="list"
                    :value="valueForKey[key]" @change="update(key, $event)"
                >
                    <template v-if="numberOfGroups > 1">
                        <template v-for="(group, name) in optionsByGroup(options[key])">
                            <template v-if="name === ''">
                                <option v-for="option in group" :key="option.value" :value="option.value">
                                    {{ option.label }}
                                </option>
                            </template>
                            <template v-else>
                                <optgroup :key="name+'-optgroup'" :label="name">
                                    <option v-for="option in group" :key="option.value" :value="option.value">
                                        {{ option.dropdownLabel ? option.dropdownLabel : option.label }}
                                    </option>
                                </optgroup>
                            </template>
                        </template>
                    </template>
                    <template v-else>
                        <option v-for="option in options[key]" :key="option.value" :value="option.value">
                            {{ option.dropdownLabel ? option.dropdownLabel : option.label }}
                        </option>
                    </template>
                </select>
            </div>
            <!-- eslint-disable max-len -->
            <a v-if="config.label === 'Railcard'" target="_blank" class="mt-1 railcard-upsell" href="https://railcards.trainsplit.com/?aff=v3-rc-dropdown"><svg class="mr-1" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 576 512"><!--! Font Awesome Pro 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path class="fa-primary" d="M0 24C0 10.7 10.7 0 24 0H69.5c26.9 0 50 19.1 55 45.5l51.6 271c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z" fill="#003e6b"></path><path fill="#62b0e8" class="fa-secondary" d="M170.7 288H459.2c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32h-411c2 4.2 3.5 8.8 4.4 13.5L170.7 288z"></path></svg>Buy a digital railcard</a>
            <p v-if="config.warning" class="mb-0 mt-2">
                {{ config.warning }}
            </p>
            <p v-if="config.error" class="mb-0 mt-2 text-danger">
                {{ config.error }}
            </p>
        </div>
    </div>
</template>

<script>
    import groupBy from 'lodash-es/groupBy';

    /* eslint-disable vue/require-prop-types */
    export default {
        name: 'DropdownList',
        props: ['value', 'config'],
        computed: {
            listKeys() {
                if (this.isSingleDropdown) {
                    return ['list'];
                }
                return Object.keys(this.config.options);
            },
            valueForKey() {
                if (this.isSingleDropdown) {
                    return {
                        list: this.value,
                    };
                }
                return this.value;
            },
            options() {
                if (this.isSingleDropdown) {
                    return {
                        list: this.config.options,
                    };
                }
                return this.config.options;
            },
            isSingleDropdown() {
                return Array.isArray(this.config.options);
            },
            numberOfGroups() {
                const temp = this.options;
                if (this.isSingleDropdown) {
                    return [...new Set(temp.list.map((item) => item.group))].length;
                }
                return 1;
            },
        },
        methods: {
            update(changeKey, event) {
                if (this.isSingleDropdown) {
                    this.$emit('input', event.target.value);
                    return;
                }
                const model = {};
                Object.keys(this.value).forEach((key) => {
                    model[key] = changeKey === key ? event.target.value : this.value[key];
                });
                this.$emit('input', model);
            },
            optionsByGroup(options) {
                return groupBy(options, (option) => option.group);
            },
        },
    };
    /* eslint-enable vue/require-prop-types */

</script>
